import React, { useEffect, useState } from 'react';
import { requestChangePassword, setChangePasswordForm } from '../../../../actions/user';
import { forceValidation } from '../../../../businessLogic/validation.js';
import { updateShowChangePasswordModal } from '../../../../actions/modal';
import { useDispatch } from 'react-redux';

const RightPanelChangePassword = (props) => {
  const dispatch = useDispatch();
  let [resetButtonClasses, setResetButtonClasses] = useState(
    'ui labeled icon button icon color-button color-button-hover color-white  max-width left-text mrlnull mrbnull disable'
  );

  useEffect(() => {
    let innterResetClasses =
      props.resetingPassword == true ? resetButtonClasses + ' loading' : resetButtonClasses.replace(' loading');

    setResetButtonClasses(innterResetClasses);
  }, [props.resetingPassword]);

  useEffect(() => {
    resetForm();
  }, []);

  const requestNewPassword = (e) => {
    let areThereErrors = forceValidation(undefined, undefined, 'changePasswordForm');
    let cb = () => {
      cancelChangePassword();
    };
    if (!areThereErrors && !window.$(e.target).hasClass('disable')) {
      dispatch(requestChangePassword(props.changePassword, props.userEmail, cb));
    }
  };
  const cancelChangePassword = () => {
    resetForm();
    dispatch(updateShowChangePasswordModal(false));
  };

  const resetForm = () => {
    setTimeout(() => {
      dispatch(setChangePasswordForm({}));
    }, 100); //wait until modal is inviisble
  };

  let cancelClassName =
    'ui  labeled icon button color-bad-things left-text color-bad-things-hover color-white max-width mrlnull mrbnull mrtsss';

  return (
    <div>
      <div className="ui actions mrbl max-width mrtxs">
        <button
          tabIndex="3"
          type="button"
          onClick={requestNewPassword}
          data-group="changePasswordForm"
          className={resetButtonClasses}
        >
          <i className="checkmark icon" />
          {APP.LANGUAGE.ResetPassword.Ok}
        </button>
        <button
          tabIndex="4"
          type="button"
          onClick={cancelChangePassword}
          className="ui  labeled icon button color-bad-things left-text color-bad-things-hover color-white max-width mrlnull mrbnull mrtsss ui  labeled icon button color-bad-things left-text color-bad-things-hover color-white max-width mrlnull mrbnull mrtm"
        >
          <i className="remove  icon" />
          {APP.LANGUAGE.Cancel}
        </button>
      </div>
    </div>
  );
};

export default RightPanelChangePassword;
